<template>
  <section
    v-if="variants.v1 === variant"
    class="tw-h-[45vh] lg:tw-h-[50vh]"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <div class="tw-w-full">
      <div class="tw-absolute tw-inset-0 tw-flex tw-items-end tw-justify-center tw-text-center">
        <MotionGroup :preset="vars.animationText ? vars.animationText : 'slideVisibleLeft'" :duration="700" is="div">
          <h1 class="tw-mb-20 lg:tw-mb-24">
            {{ vars.titleText }}
          </h1>
        </MotionGroup>
      </div>
    </div>
  </section>

  <section
    v-if="variants.v2 === variant"
    class="n-section-secondary tw-h-[45vh] lg:tw-h-[50vh]"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <div class="tw-mb-10 tw-flex tw-h-full tw-w-full">
      <div class="tw-flex tw-items-end tw-justify-start">
        <MotionGroup :preset="vars.animationText ? vars.animationText : 'slideVisibleLeft'" :duration="700" is="div">
          <h1 class="">
            {{ vars.titleText }}
          </h1>
        </MotionGroup>
      </div>
    </div>
  </section>

  <section
    v-if="variants.v3 === variant"
    class="n-section-secondary tw-h-[35vh] lg:tw-h-[42vh] lg:!tw-pb-14 xl:!tw-pb-24"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <div class="tw-flex tw-h-full tw-w-full">
      <div class="tw-flex tw-items-end tw-justify-start">
        <MotionGroup :preset="vars.animationText ? vars.animationText : 'slideVisibleLeft'" :duration="700" is="div">
          <h1 class="">
            {{ vars.titleText }}
          </h1>
        </MotionGroup>
      </div>
    </div>
  </section>

  <section class="tw-h-[100svh]" v-if="variants.v4 === variant">
    <NuxtImg
      :lazy="true"
      placeholder="blur"
      v-if="vars.mobileBackgroundImage && isMobileDevice"
      :src="vars.mobileBackgroundImage"
      class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-object-cover"
    />
    <NuxtImg
      :lazy="true"
      placeholder="blur"
      v-else-if="vars.backgroundImage"
      :src="vars.backgroundImage"
      class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-object-cover"
    />
    <div class="tw-absolute tw-inset-0 tw-z-20 tw-bg-black tw-opacity-25"></div>
    <div class="tw-relative tw-z-30 tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center">
      <div
        class="tw-z-100 tw-my-4 tw-mb-8 tw-flex tw-flex-col tw-gap-2 tw-px-3 tw-py-2 tw-text-start md:tw-px-14 md:tw-py-10 xl:tw-gap-6 xl:tw-px-10"
      >
        <h1 class="tw-mb-2 tw-text-white">
          {{ vars.titleText }}
        </h1>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'IntroSection',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
        v4: 'v4',
      },
    };
  },
});
</script>
